module.exports = __webpack_public_path__ + "static/media/SVN.866742e9.jpg";